<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/IDC3/IDC3.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">IDC3.0 Driving Domain Controller</div>
                <div class="detail-banner-desc">Qualcomm QAM8540+9000 computing platform, L3+.</div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>

                    <div class="detail-desc">
                        <div>
                            Qualcomm QAM8540+9000 Platform.<br />
                        </div>
                        <div>
                            Driving & parking integrated, up to L2+ Assistance driving.<br />
                        </div>
                        <div>
                            5 radars, 12 cameras, 12 ultrasonic radars, 3 LIDARs.<br />
                        </div>
                        <div>
                            Centimeter-level high-precision positioning.<br />
                        </div>
                        <div>
                            Liquid cooling design.<br />
                        </div>
                        <div>
                            Functional safety: ASIL-B.<br />
                        </div>
                        <div>
                            Function: Urban NOA, Freeway NOA, VPA.
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IDC3/IDC3-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">9～16V</div>
                                    <div class="k">Operating voltage range</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">13.5V</div>
                                    <div class="k">Working voltage</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≤0.4mA</div>
                                    <div class="k">Static current</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">32GB+128GB</div>
                                    <div class="k">Storage</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">360 TOPS</div>
                                    <div class="k">Computing power</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: 'IDC3.0 Driving Domain Controller - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/IDC3.html'

};

import { createApp } from 'vue';
import App from './IDC3.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./IDC3.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
